import { composeIO } from 'react-compose-io'
import { ValidacaoEstruturaCicloView } from './ValidacaoEstruturaCiclo.View'
import { ValidacaoEstruturaCicloIO } from './ValidacaoEstruturaCiclo.IO'

export const ValidacaoExecucaoCiclo = composeIO(ValidacaoEstruturaCicloView, ValidacaoEstruturaCicloIO)
